var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomInput',{attrs:{"field":{..._vm.deafult_input, readonly: _vm.readonly, value: new String(_vm.value)}},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }